<template>
  <div
    class="slider"
  >
    <div class="slider__info">
      <PaginationDots
        class="slider__info__dots"
        :current-slide="current"
        :slides="total"
        @click="scrollSnapTo"
      />
    </div>
    <div class="slider__controls">
      <div class="slider__controls__left" @click="slideItLeft()">
        <v-icon class="slider__controls__left__icon" name="caret" width="12" />
      </div>
      <div class="slider__controls__right" @click="slideItRight()">
        <v-icon class="slider__controls__right__icon" name="caret" width="12" />
      </div>
    </div>
    <div
      ref="track"
      class="slider__track"
      @scroll="setScroll"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import VIcon from "../v-icon/v-icon.vue";
import PaginationDots from "./pagination-dots/v-pagination-dots.vue";

export default {
  name: "Slider",
  components: {
    PaginationDots,
    VIcon
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    auto: {
      type: Boolean,
      default: false
    },
    slideInterval: {
      type: [String, Number],
      default: 5000
    }
  },
  data() {
    return {
      current: 1,
      slide: 0,
      total: 0
    };
  },
  mounted() {
    // auto slider
    if (this.auto) {
      setInterval(() => {
        const track = this.$refs.track;
        const slideWidth = track.offsetWidth;

        if (this.slide < this.total - 1) {
          this.slide++;
          track.scrollLeft = this.current++ * slideWidth;
        } else {
          this.slide = 0;
          this.current = 1;
          track.scrollLeft = this.current;
        }
      }, this.slideInterval);
    }
    // get number of slides
    this.total = this.$refs.track.children.length;
  },
  methods: {
    scrollSnapTo(slide) {
      this.slide = slide - 1;
      const track = this.$refs.track;
      const slideWidth = track.offsetWidth;

      track.scrollLeft = (slide - 1) * slideWidth;
    },
    setScroll() {
      const track = this.$refs.track;
      const slideWidth = track.offsetWidth;
      const currentScrollPosX = track.scrollLeft;

      this.current = Math.ceil(currentScrollPosX / slideWidth + 0.5);
    },
    slideItLeft() {
      const track = this.$refs.track;
      const slideWidth = track.offsetWidth;

      if (this.slide > 0) {
        track.scrollLeft = (this.slide -= 1) * slideWidth;
      } else {
        this.slide = this.total - 1;
        track.scrollLeft = (this.total - 1) * slideWidth;
      }
    },
    slideItRight() {
      const track = this.$refs.track;
      const slideWidth = track.offsetWidth;

      if (this.slide < this.total - 1) {
        this.slide++;
        track.scrollLeft = this.current++ * slideWidth;
      } else {
        this.slide = 0;
        this.current = 1;
        track.scrollLeft = this.current;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/component.scss";

.slider {
  position: relative;

  &__controls {
    display: none;

    @include media-breakpoint-up(md) {
      padding: 0 1vw;
      display: flex;
      justify-content: space-between;
      position: absolute;
      width: 100%;
      top: 50%;
      z-index: 10;
    }

    @media screen and (min-width: 1600px) {
      padding: 0 10vw;
    }

    &__left {
      cursor: pointer;
      display: flex;
      justify-content: center;
      background-color: theme-color("white");
      border-radius: 50%;
      width: 22px;
      height: 22px;
      box-shadow: 0px 0px 2px 0px theme-color("placeholder");

      &__icon {
        transform: rotate(90deg);
      }
    }

    &__right {
      cursor: pointer;
      display: flex;
      justify-content: center;
      background-color: theme-color("white");
      border-radius: 50%;
      width: 22px;
      height: 22px;
      box-shadow: 0px 0px 2px 0px theme-color("placeholder");

      &__icon {
        transform: rotate(270deg);
      }
    }
  }

  &__info {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    bottom: 0;
    z-index: 10;

    &__dots {
      margin: 0 auto;
    }
  }

  &__title {
    text-transform: uppercase;
  }

  &__track {
    display: grid;
    grid-auto-columns: 100%;
    gap: 12px;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      display: none;
    }

    & > * {
      display: flex;
      grid-row: 1 / -1;
      scroll-snap-align: center;
      overflow: hidden;
    }
  }
}
</style>
